import { render, staticRenderFns } from "./zbclass.vue?vue&type=template&id=1d88b896&scoped=true"
import script from "./zbclass.vue?vue&type=script&lang=js"
export * from "./zbclass.vue?vue&type=script&lang=js"
import style0 from "./zbclass.vue?vue&type=style&index=0&id=1d88b896&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d88b896",
  null
  
)

export default component.exports